import API from './api';

export default API;
